<template>
  <div class="pb-2">
    <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between items-center">
        <h2 class="font-semibold leading-tight truncate text-single-line break-all text-2xl mt-0">{{ form.code.value ? form.code.value : '' }}</h2>
         <div class="flex  items-end">
            
            <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer hover:opacity-60 mb-2"/> -->
            <!-- <div class="flex justify-end"> -->
              <button @click.prevent="update()" class="  tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3">
                SAVE
              </button>
              <button @click.prevent="deleteRecordConfirm()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
              <!-- <mdicon @click.prevent="deleteRecordConfirm()" class="bg-white hover:bg-theme-red hover:text-white text-red-500 rounded cursor-pointer px-2 py-2" name="trash-can-outline" /> -->
            <!-- </div> -->
          </div>

      </div>
    </div>

    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" v-if="loading">
      <block-loading/>
    </div>

    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" v-else>
  
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.code.error_type)">
            <label class="text-xs mb-1">Promocode Name</label>
            <input :disabled="form.code" v-model="form.code.value" @keyup="validateFields(['code'])" placeholder="Regular Customer" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
            <p class="field-error label-text mt-1" v-if="form.code.error_message" v-text="form.code.error_message"></p>
          </div>
        </div>
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper'">
              <label class="text-xs mb-1">Locations</label>
              <custom-select-dropdown
                class="down"
                :options="vg_allLocations"
                :placeholdertext="`Select Any`"
                :callback="setSelectedLocations"
                :value="selectedLocationIds"
                valueLabel="location"
              />
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full">
          <div :class="'input-wrapper'">
            <label class="text-xs mb-1">Description</label>
            <textarea v-model="form.description.value" placeholder="Description" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"> </textarea>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.applyDiscountOn.error_type)">
            <label class="text-xs mb-1">Applied To</label>
            <select @change="validateFields(['applyDiscountOn'])" v-model="form.applyDiscountOn.value" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white">
              <option value="" disabled>--Select--</option>
              <option value="product">Product</option>
              <option value="category">Category</option>
              <option value="delivery">Delivery</option>
              <option value="cart">Cart</option>
              <option value="multiple_product_qty"> Multiple product qty </option>
            </select>
            <p class="field-error label-text mt-1" v-if="form.applyDiscountOn.error_message" v-text="form.applyDiscountOn.error_message"></p>
          </div>
        </div>
        <!-- <div class="xl:w-1/2 w-full">
          <div :class="'input-wrapper ' + (form.discountType.error_type)">
            <label class="text-xs mb-1">Discount Type</label>
            <select @change="validateFields(['discountType'])" v-model="form.discountType.value" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white">
              <option value="" disabled>--Select--</option>
              <option value="percentage">Percentage</option>
              <option value="flat">Dollar Amount</option>
            </select>
            <p class="field-error label-text mt-1" v-if="form.discountType.error_message" v-text="form.discountType.error_message"></p>
          </div>
        </div> -->

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper ' + (form.discount.error_type)">
            <label class="text-xs mb-1">Value</label>
            <div class="block rounded bg-gray-black w-full relative">

              <mdicon v-if="valueTypePercentage" size="18" name="percent" class="absolute top-[9px] left-1" />
              <mdicon v-else size="20" name="currency-usd" class="absolute top-[8px] left-1" />

              <input @keyup="validateFields(['discount'])" :onkeypress="preventNonNumbers" v-model="form.discount.value" placeholder="50" class="pr-[60px] pl-[30px] placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" min="0" type="number">
              <label class="flex items-center cursor-pointer absolute right-1 top-2">
                <input type="checkbox" v-model="valueTypePercentage" class="hidden peer">
                <div :class="'relative toggle-bg label-inside-switch border-2  h-6 w-11 rounded-full ' + (valueTypePercentage ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                  <span :class="'text-white ' + (valueTypePercentage ? 'left' : 'right')">
                    <mdicon :size="valueTypePercentage ? '13'  : '15'" :name="valueTypePercentage ? 'percent'  : 'currency-usd'" class="top-[6px] right-[2px] relative"/>
                  </span>
                </div>
              </label>
            </div>
            <p class="field-error label-text mt-1" v-if="form.discount.error_message" v-text="form.discount.error_message"></p>
          </div>
        </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="xl:w-1/2 w-full">
          <div :class="'input-wrapper ' + (form.userType.error_type)">
            <label class="text-xs mb-1">User Type</label>
            <select v-model="form.userType.value" @change="validateFields(['userType'])" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white">
              <!-- <option value="" disabled>--Select--</option> -->
              <option value="registered">Registered</option>
              <option value="guest">Guest</option>
              <option value="all">All</option>
            </select>
            <p class="field-error label-text mt-1" v-if="form.userType.error_message" v-text="form.userType.error_message"></p>
          </div>
        </div>
        <div class="xl:w-1/2 w-full">
          <div v-if="form.applyDiscountOn.value =='category'" class="input-wrapper relative">
            <label class="mb-0 text-xs">Participating Items</label>
            <SelectCheckbox v-model="selectedCatIds" :options="categories" placeholder="Select" class="relative  w-full h-[40px] rounded bg-gray-black focus:border-0 focus:ring-0 border-0" :class="selectedCatIds.length>0?'text-white':'text-theme-878686'" />
          </div>
          <div v-else class="input-wrapper">
            <label class="text-xs mb-1">Participating Items</label>
            <div class="flex justify-between items-center">
              <span class="placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none">{{ selectedPids.length }} item{{ selectedPids.length > 1  ? 's' : '' }} selected</span>
              <div class="flex justify-between items-center">
                <a href="#" @click.prevent="showCategoryWithProductModal()" class="bg-white p-[6px] rounded hover:bg-opacity-60">
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.3 19.1508L2.75 15.6008L3.8 14.5508L6.3 17.0258L10.775 12.5508L11.825 13.6258L6.3 19.1508ZM6.3 11.1508L2.75 7.60078L3.8 6.55078L6.3 9.02578L10.775 4.55078L11.825 5.62578L6.3 11.1508ZM13.75 17.2508V15.7508H22.75V17.2508H13.75ZM13.75 9.25078V7.75078H22.75V9.25078H13.75Z"
                          fill="#2BA66B" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Min Purchase</label>
            <div class="relative">
              <mdicon size="20" name="currency-usd" class="absolute top-[8px] left-1" />
              <input v-model="form.minAmount.value"  :onkeypress="preventNonNumbers" placeholder="Regular Customer"
              class="placeholder-theme-878686 pl-[25px] block border-none rounded bg-gray-black w-full text-sm text-theme-white"
              min="0" type="number">
            </div>

          </div>
        </div>


        <div v-if="form.discountType.value==='percentage'" class="w-full xl:w-1/2">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Max Discount</label>
            <div class="relative">
              <mdicon size="20" name="currency-usd" class="absolute top-[8px] left-1" />
              <input v-model="form.maxDiscountAmount.value" :onkeypress="preventNonNumbers" placeholder="Regular Customer"
              class="pl-[25px] placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"
              min="0" type="number">
            </div>
          </div>
        </div>
      </div>
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Limit Per User</label>
            <input v-model="form.maxUsePerPerson.value" :onkeypress="preventNonNumbers" placeholder="Regular Customer"
            class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"
            min="0" type="number">
          </div>
        </div>

        <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Max use</label>
            <input v-model="form.maxUse.value" :onkeypress="preventNonNumbers" placeholder="Regular Customer"
            class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"
            min="0" type="number">
          </div>
        </div>
      </div>
      <div class="flex gap-2 xl:flex-row flex-col pb-2">
        <div class="xl:w-1/2 w-full">
          <div :class="'input-wrapper clearable '">
            <label class="text-xs mb-1">Start Date</label>
            
            <div class=" bg-gray-black rounded w-full flex items-center">
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                </svg>
              </span>
              
              <Datepicker :clearable="true" :inputFormat="'yyyy-MM-dd'" :lowerLimit="new Date()" placeholder="Select a Date" v-model="form.startDate.value" class="focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full text-sm"/>
            </div>
          </div>
        </div>
        <div class="xl:w-1/2 w-full">
          <div :class="'input-wrapper clearable ' ">
            <label class="text-xs mb-1">End Date</label>
            <div class=" bg-gray-black rounded w-full flex items-center">
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                </svg>
              </span>
              <Datepicker :clearable="true" :inputFormat="'yyyy-MM-dd'" :lowerLimit="endDateLimit" placeholder="Select a Date" v-model="form.endDate.value" class="focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full text-sm"/>
            </div>
          </div>
        </div>
      </div>
  
      <!-- <div class="bg-theme-borderblack h-1 w-full my-4"></div> -->
      <!-- <div class="flex gap-3 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-2/4">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Schedule</label>
            <select v-model="form.schedule" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white">
              <option value="" disabled>--Select--</option>
              <option value="compound">Compound</option>
              <option value="primary">Primary</option>
            </select>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <CategoryWithProductModal v-if="categoryWithproductObj.active" title="Participating Items" :existingproducts="selectedPids" :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
  <ReturnConfirmModal v-if="deleteObj.modal" :obj="deleteObj.obj" :closeClick="closeDeleteModal" :actionClick="deleteNow" :heading="'You Are About To Delete ' + deleteObj.obj.code "/>
</template>
<script>
  import { defineComponent, ref} from "vue"
  import {mapGetters,mapActions} from "vuex";
  import ProductApi from '@/controllers/BusinessProductApis'
  import { useSnackbar} from "vue3-snackbar";
  import Datepicker from 'vue3-datepicker'
  import Helpers from '@/helpers';
  import CategoryWithProductModal from '@/components/CategoriesWithProductModal.vue';
  import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
  import ProductPromotionApis from "@/controllers/ProductPromotionApis";
  import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";
  import moment from 'moment';

  export default defineComponent({
    name: "ProductPromotionsEdit",
    components: {
      Datepicker,
      SelectCheckbox,
      CategoryWithProductModal,
      ReturnConfirmModal
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      clearComponent: {
        type: Function,
        required: true,
      },
    },
    setup() {
      const snackbar = useSnackbar();
      const valueTypePercentage = ref(false)
      const form = ref({
        code: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        description: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        userType: {
          value: 'guest',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        applyDiscountOn: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        discount: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'maxval:99|when|discountType:percentage'],
        },
        discountType: {
          value: 'percentage',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        maxUse: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        maxUsePerPerson: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        minAmount: {
          value: 0,
          error_type: '',
          error_message: '',
          validations: [],
        },
        maxDiscountAmount: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        startDate: {
          value: null,
          error_type: '',
          error_message: '',
          validations: [],
        },
        endDate: {
          value: null,
          error_type: '',
          error_message: '',
          validations: [],
        },
      });
      const categoryWithproductObj = ref({
        active: false,
      });
      const deleteObj = ref({
        modal: false,
        obj: {},
      });
      const loading = ref(false);
      const selectedLocationIds = ref([]);
      const categories = ref([])
      const selectedPids = ref([]);
      const selectedCatIds = ref([])
      return {
        categoryWithproductObj,
        snackbar,
        valueTypePercentage,
        form,
        loading,
        deleteObj,
        selectedLocationIds,
        categories,
        selectedPids,
        selectedCatIds
      };
    },
    watch:{
      'form.startDate.value'(val) {

        this.validateFields(['startDate']);
        if(this.form.endDate.value != null || this.form.endDate.value != 'Invalid date') {
          // then need to check
          let endDate = moment(this.form.endDate.value);
          let startDate = moment(this.form.startDate.value);
          let dayGap = endDate.diff(startDate, 'day');
          if(dayGap < 0) {
            this.snackbar.add({
              type: 'info',
              text: 'End date must be equal or greater than start date.',
              duration: 3000,
            })
            this.form.endDate.value = null;
          }
          
        }
      },
      'form.endDate.value'(val) {
        
        this.validateFields(['endDate']);
        let endDate = moment(this.form.endDate.value);
        let startDate = moment(this.form.startDate.value);
        let dayGap = endDate.diff(startDate, 'day');
        if(dayGap < 0) {
          this.snackbar.add({
            type: 'info',
            text: 'End date must be equal or greater than start date.',
            duration: 3000,
          })
          this.form.endDate.value = null;
        }
      },

      'item.id'() {
        if(this.loading == false) { this.assignValues(); };
      },
  
      
      'form.discount.value'(val, oldVal) {
        this.form.discount.value = (val && val > 99999999) ? oldVal : val;
      },

      'valueTypePercentage' (val) {
        this.form.discountType.value = val ? 'percentage' : 'flat';
        if(this.loading == false) { this.validateFields(['discount']) };
      },
   
  },

    computed: {
    
      endDateLimit() {
        return this.form?.startDate ?  moment(this.form.startDate).toDate() : new Date();
      },
      ...mapGetters({
        vg_activeBusiness: 'auth/activeBusiness',
        vg_allLocations: 'location/list',
      }),
    },

    async mounted() {
      this.assignValues();
      await this.getCategory()
    },

  methods: {
    async getCategory(){
      let res = await ProductApi.fetchAllCategory()
      if(res.data?.payload?.category){
        for(let i=0; i<res.data.payload.category.length; i++){
          this.categories.push(res.data.payload.category[i])
          if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
              for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                  this.categories.push(res.data.payload.category[i].subCategories[j])
              }
          }
        }
      }
    },


    async assignValues() {
      
      const self = this;
      this.loading = true;
      this.valueTypePercentage = (this.item.discountType == 'percentage') ? true : false;
      // let get the location and products fo this promocode
      let productsAssignedlist = ProductPromotionApis.fetchAssignedProducts(this.item.id);
      let locationsAssignedList = ProductPromotionApis.fetchAssignedLocations(this.item.id);
      let categoryAssignedlist = ProductPromotionApis.fetchAssignedCategories(this.item.id);
      await Promise.all([productsAssignedlist, locationsAssignedList, categoryAssignedlist]).then(async function (res) {
        self.selectedPids = [];
        if(res[0] && res[0].status == 200) {
          res[0].data.payload.forEach( (product) => {
              self.selectedPids.push(product.productId)
          })
        }
        self.selectedLocationIds = [];
        if(res[1] && res[1].status == 200) {
          res[1].data.payload.forEach( (location) => {
              self.selectedLocationIds.push(location.locationId)
          })
        }
        self.selectedCatIds = [];
        if(res[2] && res[2].status == 200) {
          res[2].data.payload.forEach( (category) => {
            self.selectedCatIds.push(category.id)
          })
        }
      })
      
      this.form = await Helpers.assignFormValues(this.form, this.item);
      this.form.startDate.value = this.item.startDate ? moment(this.item.startDate).toDate() : '';
      this.form.endDate.value = this.item.endDate ? moment(this.item.endDate).toDate(): '';
      this.$nextTick(() => {
        this.loading = false;
      })
    },
    
      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },

      /**
       * Update data
       */
      async update() {
        
        // validate business field
        let validate = await this.validateFields([
          'code', 'applyDiscountOn', 'discount', 'userType'
        ]);
        if (!validate) {
          return;
        }

       this.va_spinner(true);
       
       let dataClone = {
          code: this.form.code.value,
          description: this.form.description.value,
          userType: this.form.userType.value,
          applyDiscountOn: this.form.applyDiscountOn.value,
          discount: this.form.discount.value,
          discountType: this.form.discountType.value,
          maxUse: this.form.maxUse.value,
          maxUsePerPerson: this.form.maxUsePerPerson.value,
          minAmount: this.form.minAmount.value,
          maxDiscountAmount: this.form.maxDiscountAmount.value,
          startDate: this.form.startDate.value ? moment(this.form.startDate.value).format('YYYY-MM-DD') : null,
          endDate: this.form.endDate.value ? moment(this.form.endDate.value).format('YYYY-MM-DD') : null
       }

        // let data = await Helpers.getFormKeyValue(dataClone);
        // console.log(data);
        let res = await ProductPromotionApis.update(this.item.id, dataClone);

        // these can be done on background
        
        let locationIDs = [];
        if(this.selectedLocationIds && this.selectedLocationIds[0].id){
          this.selectedLocationIds.forEach( (loc) => {
            locationIDs.push(loc.id);
          })
        }else{
          locationIDs = this.selectedLocationIds
        }

        await ProductPromotionApis.assignLocations(this.item.id, locationIDs);
        if(this.form.applyDiscountOn.value==='category'){
          await ProductPromotionApis.assignCategories(this.item.id, this.selectedCatIds);
        }else{
          await ProductPromotionApis.assignProducts(this.item.id, this.selectedPids);
        }
        // await Promise.all([productAssign, locationAssign]).then( res => {
        // })
        // background api ends 

        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : res.response.data.message[0],
          duration: 3000,
        })
        if(res.status == 200 ) {
          this.clearComponent();
          this.emitter.emit("refresh-product-promotions-list", true);
        }
      },

      
      /**
       * Do not allow to add +,-,e
       */
      preventNonNumbers(e) {
        var ASCIICode = (e.which) ? e.which : e.keyCode
        if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101) {
          return false;
        }
        return true;
      },

      /**
       * Open product with category Model
       */
      showCategoryWithProductModal() {
        this.categoryWithproductObj.active = true;
      },

      /**
       * Close select category modal
       */
      closeCategoryWithProductModal() {
        this.categoryWithproductObj.active = false;
      },

     /**
       * Get data selected from category modal
       */
      setCategoriesWithProduct(data) {
        this.selectedPids = data.pids;
        this.closeCategoryWithProductModal();
      },

      /**
     * Open Delete confirm
     */
    async deleteRecordConfirm() {
      this.deleteObj = {
        modal: true,
        obj: this.item,
      };
    },

    /**
     * Close delete confirm 
     */
    closeDeleteModal() {
      this.deleteObj = {
        modal: false,
        obj: {},
      };
    },

    /**
     * Delete 
     */
    async deleteNow(obj) {
      this.va_spinner(true);
      let res = await ProductPromotionApis.delete(obj.id);
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 200 ) {
        this.emitter.emit("refresh-product-promotions-list", true);
        this.clearComponent();
      }
    },

    /**
     * SetSelectedLocations
     */
    setSelectedLocations(data) {
      this.selectedLocationIds = data;
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
    
  });
</script>